import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import SubHeader from "../ProcessSteps/Parts/SubHeader";
import Header from "../ProcessSteps/Parts/Header";
import {Redirect} from "react-router";
import {Form, Formik} from "formik";
import {NumberField} from "../Fields";
import {toast} from "react-toastify";
import Loading from "../ProcessSteps/Parts/Loading";

class BadIncomes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showEditForm: false,
            redirect_url: null,
            initialValues: {
                incomes: ''
            }
        };

        this.gotToIncomes = this.gotToIncomes.bind(this);
        this.useTheseIncomes = this.useTheseIncomes.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
    }

    useTheseIncomes() {
        axios.get('/api/process/' + this.props.application_token + '/skip_income_clarification')
            .then(
                data => {
                    if (data.data.status === 'success') {
                        this.setState({redirect_url: this.props.suggestion.process_step_urls.choose_terms});
                    }
                },
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            })
    }

    gotToIncomes() {
        this.setState({showEditForm: true});
    }

    renderForm(props) {
        return (<Fragment>
                {!this.props.suggestion ?
                    <Loading/>
                    :
                    <Form className="form form-layout">

                        <div className="container form-layout__2-col">
                            <div className="form-group  col-md-6 col-lg-6">
                                <NumberField
                                    label={this.props.t('forms.monthly_income')}
                                    name="incomes"
                                    {...props}
                                />
                            </div>
                        </div>

                        <div className="form-group col-12 d-flex justify-content-center mt-3">
                            <button type="submit"
                                    className="btn btn-primary btn-lg"
                                    disabled={props.isSubmitting}
                            >
                                {this.props.t('forms.save')}
                            </button>
                        </div>
                    </Form>
                }
            </Fragment>
        );
    }

    formSubmit(values, actions) {
        axios.post('/api/process/' + this.props.application_token + '/update_incomes', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        this.setState({redirect_url: '/' + this.props.application_token + '/process/choose_terms'});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    toast.error(response_data.message);
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            return <Redirect push={true} to={this.state.redirect_url}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.error')}/>
                <div className="section window-layout">
                    <div className="container frame">
                        {/*<SubHeader title=""/>*/}

                        <div className="row py-5">

                            <div className="col-12 d-flex justify-content-center text-center mt-4">
                                <p className="heading--2">
                                    Išorinėsė duomenų bazėse pastebėjome, jog jūsų gaunamos pajamos yra kiek didesnės,
                                    nei nurodėte. Galbūt norėtumėte patikslinti?
                                </p>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 text-center mt-4">
                                <button className="btn btn-primary"
                                        onClick={this.useTheseIncomes}
                                >
                                    Naudoti nurodytas pajamas
                                </button>
                            </div>

                            <div className="col-12 col-md-6 col-lg-6 text-center mt-4">
                                {!this.state.showEditForm &&
                                <button className="btn btn-primary"
                                        onClick={this.gotToIncomes}
                                >
                                    Patikslinti
                                </button>
                                }

                                {this.state.showEditForm &&
                                <div className="text-center">
                                    <Formik
                                        initialValues={this.state.initialValues}
                                        render={this.renderForm}
                                        onSubmit={this.formSubmit}
                                        enableReinitialize={true}
                                        handleReset={(values, formikBag) => {
                                            console.log(values, formikBag)
                                        }}
                                    />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(BadIncomes);
